export enum PollType {
  POLL_TYPE_NONE,
  POLL_TYPE_SINGLE,
  POLL_TYPE_MULTIPLE
}
